import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Force scroll to top on every route change.
 * React Router does not do this by default — and it's the right default for
 * a multi-step funnel like Landing → /run → /results.
 */
export default function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    // immediate, not smooth — instant feedback that the page changed.
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname]);
  return null;
}
